import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { FadeUp } from "../components/Reveal";
import { PageHero } from "../components/PageHero";
import { ArtworkCarousel } from "../components/ArtworkCarousel";
import { usePageTitle } from "../hooks/usePageTitle";
import { Lightbox } from "../components/Lightbox";

const CATS = [
  ["all", "ALL"],
  ["pop-culture", "POP CULTURE"],
  ["portraits", "PORTRAITS"],
  ["street", "STREET"],
  ["originals", "ORIGINALS"],
];

export default function Art() {
  usePageTitle("The Work — Original Art");
  const [artworks, setArtworks] = useState([]);
  const [cat, setCat] = useState("all");
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    api.get("/artworks").then((r) => setArtworks(r.data)).catch(() => {});
  }, []);

  const filtered = cat === "all" ? artworks : artworks.filter((a) => a.category === cat);

  return (
    <div className="pb-20" data-testid="art-page">
      <PageHero slug="piece-01" testId="art-hero">
        <FadeUp>
          <p className="text-[10px] font-bold tracking-[0.3em] text-smoke mb-3">PORTFOLIO — KENNY DEPRINCE</p>
          <h1 className="font-display text-6xl sm:text-7xl tracking-wide leading-none" data-testid="art-page-title">THE WORK</h1>
        </FadeUp>
      </PageHero>

      <div className="px-5 sm:px-8">
      <FadeUp delay={0.1} className="mt-8 flex gap-2 overflow-x-auto pb-2 -mx-5 px-5 sm:mx-0 sm:px-0" data-testid="art-filters">
        {CATS.map(([key, label]) => (
          <button
            key={key}
            onClick={() => setCat(key)}
            data-testid={`filter-${key}`}
            className={`shrink-0 min-h-[44px] px-5 text-xs font-extrabold tracking-[0.15em] border transition-colors duration-200 ${
              cat === key ? "bg-bone text-ink border-bone" : "border-white/20 text-bone/70 hover:border-pink hover:text-pink"
            }`}
          >
            {label}
          </button>
        ))}
      </FadeUp>

      <FadeUp delay={0.15} className="mt-10">
        {filtered.length > 0 ? (
          <ArtworkCarousel artworks={filtered} onOpen={setLightbox} testIdPrefix="art" />
        ) : (
          <p className="text-sm text-smoke py-10" data-testid="art-empty">No pieces in this category yet.</p>
        )}
      </FadeUp>

      <FadeUp className="mt-16 border-t border-white/10 pt-6">
        <p className="text-[10px] tracking-[0.3em] text-smoke" data-testid="art-copyright">ALL ARTWORK © KENNY DEPRINCE</p>
      </FadeUp>

      </div>

      {lightbox !== null && (
        <Lightbox artworks={filtered} startIndex={lightbox} onClose={() => setLightbox(null)} />
      )}
    </div>
  );
}
